// predictive-search.js — live search suggestions using Shopify's native endpoint
(function () {
  const input = document.querySelector('[data-bc-predictive-search-input]');
  const resultsBox = document.querySelector('[data-bc-predictive-search-results]');
  if (!input || !resultsBox) return;

  let debounceTimer;
  let lastQuery = '';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderResults(data, query) {
    const products = data.resources.results.products || [];
    const collections = data.resources.results.collections || [];
    const articles = data.resources.results.articles || [];

    if (products.length === 0 && collections.length === 0 && articles.length === 0) {
      resultsBox.innerHTML = `<p class="bc-search-no-results">No results for "${query}"</p>`;
      return;
    }

    let html = '';

    if (collections.length) {
      html += '<div class="bc-search-group"><p class="bc-search-group__title">Collections</p><div class="bc-search-collections">';
      collections.forEach((c) => {
        html += `<a href="${c.url}" class="bc-search-collection-chip">${c.title}</a>`;
      });
      html += '</div></div>';
    }

    if (products.length) {
      html += '<div class="bc-search-group"><p class="bc-search-group__title">Products</p><div class="bc-search-products">';
      products.forEach((p) => {
        const img = p.featured_image ? p.featured_image.url : '';
        html += `
          <a href="${p.url}" class="bc-search-product">
            ${img ? `<img src="${img}&width=120" alt="${p.title}" loading="lazy">` : ''}
            <div>
              <p class="bc-search-product__title">${p.title}</p>
              <p class="bc-search-product__price">${money(p.price)}</p>
            </div>
          </a>`;
      });
      html += '</div></div>';
    }

    if (articles.length) {
      html += '<div class="bc-search-group"><p class="bc-search-group__title">Articles</p><div class="bc-search-articles">';
      articles.forEach((a) => {
        html += `<a href="${a.url}" class="bc-search-article-link">${a.title}</a>`;
      });
      html += '</div></div>';
    }

    html += `<a href="/search?q=${encodeURIComponent(query)}" class="bc-search-view-all">View all results for "${query}"</a>`;
    resultsBox.innerHTML = html;
  }

  function search(query) {
    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,article&resources[limit]=6&resources[options][unavailable_products]=last`;
    fetch(url)
      .then((res) => res.json())
      .then((data) => renderResults(data, query))
      .catch((err) => console.error('Predictive search failed:', err));
  }

  input.addEventListener('input', () => {
    const query = input.value.trim();
    clearTimeout(debounceTimer);

    if (query.length < 2) {
      resultsBox.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(() => {
      if (query !== lastQuery) {
        lastQuery = query;
        search(query);
      }
    }, 250);
  });
})();
